<template>
    <div class="daywrap">
        <div class="dayTitle">
            {{dayTitle}}
        </div>
        <div class="alldayEvents">
            <calendar-all-day-view :events="events" :date="startDate"></calendar-all-day-view>
        </div>

        <div class="dayView">
            <calendar-day-view :events="events" :date="startDate"></calendar-day-view>
        </div>
    </div>
</template>

<script>
import CalendarDayView from '@/components/calendarDayView';
import CalendarAllDayView from '@/components/calendarAllDayView';
import { DateTime } from 'luxon';

export default {
  name: 'calendarDay',
  components: { CalendarDayView, CalendarAllDayView },
  props: {
    events: Array,
    startDate: Object
  },
  computed: {
    dayTitle() {
      return this.startDate.toLocaleString(DateTime.DATE_HUGE);
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .alldayEvents {
        overflow-y: scroll;
        overflow-x: hidden;
        max-height: 5em;
        .alldayView {
            overflow-x: hidden;
            border-left: 1px solid $calendar-week-border;
        }
        border-bottom: 2px solid $calendar-week-border;
    }

    .daywrap {
        display: flex;
        flex-direction: column;
        height: 100%;
        .dayView {
            flex: 1;
            width: 100%;
            overflow-x: hidden;
            overflow-y: scroll;
            height: 48 * $calendar-day-row;
        }
        .dayTitle {
            flex: 0 0 auto;
            text-align: center;
            font-weight: bold;
        }
    }

</style>
